import { useState } from "react";
import { motion } from "framer-motion";
import contactUs from "./images/contactUsImg.jpeg";
import Footer from "../../components/Footer";
import mapImage from "./images/mapImg.jpeg";
import { LuPhone } from "react-icons/lu";
import { GoMail } from "react-icons/go";
import { IoLocationOutline } from "react-icons/io5";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <>
      <div className="w-full flex flex-col gap-10 min-h-screen py-10">
        {/* header */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="flex flex-col mt-6 lg:flex-row items-center shadow-md gap-10 lg:gap-16 bg-white rounded-2xl py-6 lg:py-10 mx-4 sm:mx-10 lg:mx-20"
        >
          <div className="flex w-full lg:w-1/2 xl:px-20 justify-center">
            <img
              src={contactUs}
              alt="بارسرا"
              className="w-full max-w-[300px] sm:max-w-sm lg:max-w-full rounded-xl object-contain"
            />
          </div>

          <div className="flex w-full lg:w-1/2 justify-center lg:justify-start lg:text-start lg:items-start font-inter">

            <motion.div
              variants={fadeUp}
              initial="hidden"
              animate="show"
              transition={{ delay: 0.2 }}
              className="flex flex-col items-center justify-between text-center gap-6 lg:w-2/3 w-1/2"
            >
              <div className="flex flex-col gap-2 w-full">
                <p className="text-[18px] sm:text-[20px] lg:text-[24px] font-bold text-blue-950">
                  با ما در تماس باشید
                </p>
              </div>

              <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-light text-special leading-relaxed">
                ما اینجا هستیم تا به سؤالات شما پاسخ دهیم و به شما کمک کنیم.
                لطفاً فرم را پر کنید یا از اطلاعات تماس مستقیم ما استفاده نمایید.
              </p>
            </motion.div>
          </div>
        </motion.div>

        {/* form */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center gap-10 justify-between lg:px-10 px-5 w-full bg-blue_light mt-5 lg:py-10 py-6 rounded-2xl"
        >
          <p className="lg:text-[22px] text-[18px] text-special font-bold">
            ارسال پیام
          </p>

          <div className="w-full flex flex-col gap-10 lg:px-10 px-2">
            <div className="w-full flex flex-col lg:flex-row justify-between gap-5">

              <div className="flex flex-col gap-3 w-full">
                <label>نام و نام خانوادگی</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="نام و نام خانوادگی شما"
                  className="rounded-[10px] px-4 lg:w-[300px] w-full h-[45px] sm:h-[50px] border border-gray-700 outline-blue-700"
                />
              </div>

              <div className="flex flex-col gap-3 w-full">
                <label>شماره تماس</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="شماره تماس شما"
                  className="rounded-[10px] px-4 lg:w-[300px] w-full h-[45px] sm:h-[50px] border border-gray-700 outline-blue-700"
                />
              </div>
            </div>

            <div className="flex flex-col gap-3 w-full">
              <label>ایمیل</label>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="ایمیل"
                className="rounded-[10px] px-4 w-full sm:w-[320px] h-[45px] sm:h-[50px] border border-gray-700 outline-blue-700"
              />
            </div>

            <div className="flex flex-col w-full gap-2">
                <label htmlFor="message" className="text-gray-700 font-medium">
                  پیام شما
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={120}
                  placeholder="پیام خود را بنویسید..."
                  className="rounded-[10px] px-4 py-3 w-full lg:h-[320px] h-[200px] resize-none border border-gray-700 outline-blue-700 text-start"
                />
                <span className="text-sm text-gray-500 text-end">
                  {formData.message.length}/120 کاراکتر
                </span>
            </div>

            <div className="w-full flex justify-center items-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="h-[45px] sm:h-[50px] rounded-md w-[180px] sm:w-[200px] bg-special text-white hover:bg-white hover:text-special border border-special transition-colors duration-300"
              >
                ارسال پیام
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* contact info */}

        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.3 }}
          className="flex flex-col lg:flex-row justify-between items-center w-full gap-10 px-5 lg:px-20"
        >
          <div className="flex w-full lg:w-1/2 justify-center">
            <img
              src={mapImage}
              alt="بارسرا"
              className="w-full max-w-[300px] sm:max-w-sm lg:max-w-[400px] rounded-xl object-contain"
            />
          </div>

          <div className="flex w-full lg:w-1/2 justify-center lg:justify-end lg:text-start lg:items-start font-inter">

            <div className="flex flex-col items-end justify-between text-end gap-6 w-full lg:w-max lg:px-10 px-10">
              <p className="text-[18px] sm:text-[20px] lg:text-[24px] font-bold text-blue-950">
                اطلاعات تماس
              </p>

              <div className="flex flex-col items-end text-end gap-6 w-full">
                <div className="flex gap-3 sm:gap-5 justify-end w-full">
                  <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-light text-special leading-relaxed">
                    ۵۶۷۸ ۱۲۳۴ ۲۱ ۹۸+
                  </p>
                  <LuPhone size={20} className="text-special" />
                </div>

                <div className="flex gap-3 sm:gap-5 justify-end w-full">
                  <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-light text-special leading-relaxed">
                    خیابان ولیعصر، کوچه بارسرا، پلاک ۱۲، تهران، ایران
                  </p>
                  <IoLocationOutline size={20} className="text-special" />
                </div>

                <div className="flex gap-3 sm:gap-5 justify-end w-full">
                  <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-light text-special leading-relaxed">
                    contact@barsara.com
                  </p>
                  <GoMail size={20} className="text-special" />
                </div>
              </div>
            </div>
          </div>
        </motion.div>

      </div>

      <Footer />
    </>
  );
}
